<template>
    <BModal ref="mfaModal" :title="$t('mfa.modalTitle')" centered no-close-on-backdrop header-variant="primary" modal-class="no-border-modal">
        <form class="modal-content" id="mfaModalForm" @submit.prevent="handleSubmit">
            <div class="text-center">
                <p>{{ message }}</p>
            </div>
            <div class="mb-2">
                <label class="form-label">Code</label>
                <input class="form-control" type="code" required placeholder="Entrez le code" v-model="code">
            </div>
        </form>
        <template #footer="{ cancel }">
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">Annuler</button>
                <span v-if="errorMessage" class="custom-error-msg">{{ errorMessage }}</span>
                <button type="submit" class="btn btn-primary" form="mfaModalForm">Valider</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';

export default {
    name: 'MfaModal',
    components : {
        BModal
    },
    props: {
        action: {
            type: Function,
            required: true
        }
    },
    setup(props) {
        const code = ref("");
        const mfaModal = ref(null);
        const errorMessage = ref("");
        const message = ref("");

        const show = (msg) => {
            message.value = msg;
            code.value = "";
            errorMessage.value = "";
            mfaModal.value.show();
        };

        const hide = () => {
            mfaModal.value.hide();
        };

        const showError = (msg) => {
            errorMessage.value = msg;
        };

        const handleSubmit = () => {
            hide();
            props.action(code.value);
        };

        return {
            handleSubmit,
            errorMessage,
            showError,
            mfaModal,
            message,
            show,
            hide,
            code,
        };
    },
}
</script>

<style>
.no-border-modal .modal-header {
  border-bottom: none !important;
}

.no-border-modal .modal-footer {
  border-top: none !important;
}
</style>